import { Yii } from "libraries/interfaces/Yii";

export const SUMMARY_LABELS: { [key: string]: string } = {
    from: Yii.t('wui-shared-js', 'Du'),
    to: Yii.t('wui-shared-js', 'au'),
}